import { IGdprInfo } from "@commonRendering/types";
import {
    LocalScriptContentProvider, TruFormLocalScriptContentProviderOptions
} from "../../../typings/local-script-content-provider";

export class TruFormWidgetScriptContentProvider implements LocalScriptContentProvider {

    constructor(private readonly gdprInfo: IGdprInfo) {}

    public getScriptTextContent(options: TruFormLocalScriptContentProviderOptions): string {
        const preparedWidgetId = options.elementId.replace("-", "_");

        return `
            window.__truForms = window.__truForms || {};

            var form_options_${preparedWidgetId} = {
                gdprOptions: {
                    isGdprEnabled: ${this.gdprInfo.isGdprEnabled && !options.excludeFromGdpr},
                    privacyPolicyUrl: "${this.gdprInfo.privacyPolicyPageUrl}"
                },
                styleOptions: {
                    shouldInheritCommonStyles: ${options.styleOptions?.shouldInheritCommonStyles},
                    styles: ${JSON.stringify(options.styleOptions?.styles)}
                }
            };

            window.__truForms.truFormsAppOptions = window.__truForms.truFormsAppOptions || form_options_${preparedWidgetId};

            if (window.TruForms) {
                TruForms.createAppFor("${options.formId}", "app-caller-${options.elementId}", form_options_${preparedWidgetId});
            } else {
                const script_${preparedWidgetId} = document.getElementById("${options.commonScriptId}");
                script_${preparedWidgetId}?.addEventListener("load", () => {
                    TruForms.createAppFor("${options.formId}", "app-caller-${options.elementId}",
                            {
                                ...form_options_${preparedWidgetId},
                                styleOptions: {
                                    ...form_options_${preparedWidgetId}.styleOptions,
                                    shouldInheritCommonStyles: ${options.styleOptions?.shouldInheritCommonStyles}
                                }
                            });
                }, { once: true });
            }
        `;
    }

}
